import { createTheme } from '@material-ui/core';

const brand = {
  tabNormal: '#005393',
  tabSelect: '#0db0e6',
  tabSelectBack: '#005393',
  tabBack: '#d1e1e9',
  tabDisabled: '#8c8e90',
  tableHeader: '#d1e1e9',
  black89: '#434345',
  rowUnfolded: '#FFD799',
  rowSelected: '#FFFACD',
  exportButtonFont: '#fff',
  exportButtonDefault: '#257247',
  exportButtonHovered: '#234E45',
  exportButtonFocused: '#92AC90',
};

// Default theme
const theme = createTheme({
  typography: {
    useNextVariants: true,
  },
});

const colors = {
  rangeSliderColor: '#005277',
  tableHeader: brand.tableHeader,
  logo: '#085375',
  searchInput: {
    backgroundColor: '#fff',
  },
  searchInputWithSelect: {
    select: {},
  },
  searchPage: {
    tabSelectedBackground: brand.tabSelectBack,
    tabBackground: brand.tabBack,
    filterBackground: '#F8F5F0',
    weightValueBorder: '#C4C6C8',
    ratingIconColor: '#C4C6C8',
    deliveryTermLabel: '#fff',
    uploadFileButton: {},
    downloadTemplateButton: {},
    table: {
      unfoldedRow: brand.rowUnfolded,
      selectedRow: brand.rowSelected,
    },
    excelButton: {
      // fontColor: brand.exportButtonFont,
      // default: brand.exportButtonDefault,
      // hovered: brand.exportButtonHovered,
      // focused: brand.exportButtonFocused,
    },
  },
  basketPage: {
    orderButton: {},
    deleteButton: {},
    excelButton: {
      // fontColor: brand.exportButtonFont,
      // default: brand.exportButtonDefault,
      // hovered: brand.exportButtonHovered,
      // focused: brand.exportButtonFocused,
    },
  },
  catalogPage: {},
  ordersPage: {
    excelButton: {
      // fontColor: brand.exportButtonFont,
      // default: brand.exportButtonDefault,
      // hovered: brand.exportButtonHovered,
      // focused: brand.exportButtonFocused,
    },
  },
  shipmentsPage: {
    table: {
      unfoldedRow: brand.rowUnfolded,
      selectedRow: brand.rowSelected,
    },
    shipmentDateDialog: {
      dialog: 'initial',
      textField: {
        background: 'initial',
      },
      button: {},
    },
    totalTable: {
      button: {},
    },
  },
  balancePage: {
    excelButton: {
      // fontColor: brand.exportButtonFont,
      // default: brand.exportButtonDefault,
      // hovered: brand.exportButtonHovered,
      // focused: brand.exportButtonFocused,
    },
  },
  pageHeader: {
    header: '#fff',
    loginButton: {},
    signUpButton: {},
    navLink: {
      fontColor: brand.tabNormal,
      hovered: brand.tabSelect,
      disabled: brand.tabDisabled,
    },
  },
  pageTabs: {
    tab: brand.tabNormal,
    tabSelected: brand.tabSelect,
  },
  resetPasswordPage: {
    dialog: brand.tabBack,
    textField: {
      background: '#fff',
    },
  },
  loginDialog: {
    dialog: '#fff',
    textField: {
      background: '#fff',
    },
    forgotPassword: {
      color: theme.palette.text.primary,
    },
  },
  signUpDialog: {
    dialog: '#fff',
    textField: {
      background: '#fff',
    },
    errorChip: {
      color: '#fff',
    },
  },
  userDataDialog: {
    dialog: '#fff',
    textField: {
      background: '#fff',
    },
    errorChip: {
      color: '#fff',
    },
  },
};

export default createTheme({
  spacing: 8,
  typography: {
    useNextVariants: true,
    fontFamily: ['Montserrat', 'sans-serif'],
  },
  palette: {
    background: {
      default: '#fff',
    },
    custom: { ...colors },
    primary: {
      main: brand.tabSelect,
      contrastText: '#fff',
    },
  },
  shape: {
    borderRadius: theme.shape.borderRadius / 2,
  },
  overrides: {
    MuiTableHead: {
      root: {
        background: colors.tableHeader,
      },
    },
    MuiTableRow: {
      root: {
        height: '40px',
      },
      head: {
        height: '40px',
      },
    },
    MuiTableCell: {
      root: {
        '&:last-child': {
          paddingRight: theme.spacing(1) / 2,
        },
      },
      body: {
        fontSize: theme.typography.pxToRem(12),
      },
      head: {
        color: theme.palette.text.primary,
        fontWeight: theme.typography.fontWeightRegular,
      },
    },
    MuiButton: {
      root: {
        whiteSpace: 'nowrap',
      },
      contained: {
        boxShadow: 'none',
        // '&$disabled': {
        //   backgroundColor: '#C4C6C8',
        //   color: '#fff',
        // },
      },
    },
    MuiTab: {
      root: {
        cursor: 'pointer',
        // [theme.breakpoints.up('md')]: {
        //   fontSize: theme.typography.pxToRem(13),
        //   minWidth: 120,
        // },
      },
    },
    MuiPrivateTabIndicator: {
      root: {
        height: 0,
      },
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#fff',
      },
    },
    MuiPickersToolbarButton: {
      toolbarBtn: {
        color: theme.palette.text.primary,
      },
      toolbarBtnSelected: {
        color: theme.palette.text.primary,
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        color: theme.palette.text.primary,
      },
      dayLabel: {},
    },
    MuiPickersCalendar: {
      transitionContainer: {
        minHeight: '168px',
      },
    },
    MuiPickersDay: {
      day: {
        color: theme.palette.text.primary,
        borderRadius: 'initial',
        height: '28px',
      },
      isSelected: {
        backgroundColor: brand.tabSelect,
      },
      current: {},
    },
    MuiCheckbox: {
      colorSecondary: {
        color: brand.tabNormal,
        '&$checked': {
          color: brand.tabNormal,
        },
      },
    },
  },
  props: {
    MuiTable: {
      padding: 'normal',
      size: 'small',
    },
    MuiTableCell: {
      align: 'center',
    },
    MuiTableRow: {},
    MuiInputBase: {
      margin: 'dense',
    },
  },
  tableContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    overflowX: 'auto',
  },
});
